import { ChirpError } from 'rpc-client-utils';
import type { PortalAuthErrorReason } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc';

// PortalAuthError.reason values that indicate the user is authenticated (has a
// valid membership cookie) but is not authorized to access this portal resource.
// All other failure reasons are treated as authentication failures and trigger a
// redirect to the login page.
const ACCESS_DENIED_REASONS: ReadonlySet<PortalAuthErrorReason> = new Set([
  'ACCESS_DENIED',
  'MISSING_CRM_OBJECT_ASSOCIATION',
]);

export function extractAuthErrorReason(
  error: unknown
): PortalAuthErrorReason | undefined {
  // rpc-client-utils spreads rpcError fields onto ChirpError, then wraps it as
  // syncStackError.cause. Apollo adds one more layer via networkError.
  const chirpError =
    (error as any)?.networkError?.cause ?? (error as any)?.cause;
  if (chirpError instanceof ChirpError) {
    return (chirpError as any).reason;
  }
  return undefined;
}

export function isAccessDeniedError(error: unknown): boolean {
  const reason = extractAuthErrorReason(error);
  return reason !== undefined && ACCESS_DENIED_REASONS.has(reason);
}
